// extracted by mini-css-extract-plugin
export default {"card_container":"style_card_container__2xgtu","image_container":"style_image_container__7AOBc","card_content":"style_card_content__JfGQI","click_bait":"style_click_bait__wjkJN"};